import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';

const TenantDetails: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { token } = useAuth();
    const isNew = !id;

    const [name, setName] = useState('');
    const [plan, setPlan] = useState('Free');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isNew) {
            // Fetch tenant details if editing
            // For now, we'll just mock it or leave it empty as we focus on creation
            console.log("Editing tenant", id);
        }
    }, [id, isNew]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            // TODO: Implement actual API call
            console.log("Saving tenant:", { name, plan });

            // Mock success
            setTimeout(() => {
                alert("Tenant saved successfully (Mock)");
                navigate('/admin/tenants');
            }, 1000);

        } catch (error) {
            console.error("Error saving tenant:", error);
            alert("Error saving tenant");
        } finally {
            setLoading(false);
        }
    };

    return (
        <SiteLayout>
            <Header icon='business' title={isNew ? 'Nouveau Tenant' : 'Modifier Tenant'} />
            <div style={{ marginBottom: '20px' }}>
                <button className="btn btn-secondary" onClick={() => navigate('/admin/tenants')} style={{ marginBottom: '10px' }}>
                    <i className="material-icons" style={{ verticalAlign: 'middle' }}>arrow_back</i> Retour
                </button>
                <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b' }}>
                    {isNew ? 'Nouveau Tenant' : 'Modifier Tenant'}
                </h2>
            </div>

            <div className="box" style={{ padding: '30px' }}>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Nom du Tenant</label>
                        <input
                            type="text"
                            className="form-input"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            placeholder="Ex: Ma Société"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Plan</label>
                        <select
                            className="form-select"
                            value={plan}
                            onChange={(e) => setPlan(e.target.value)}
                        >
                            <option value="Free">Free</option>
                            <option value="Pro">Pro</option>
                            <option value="Enterprise">Enterprise</option>
                        </select>
                    </div>

                    <div style={{ marginTop: '30px', display: 'flex', gap: '10px' }}>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Enregistrement...' : 'Enregistrer'}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={() => navigate('/admin/tenants')}>
                            Annuler
                        </button>
                    </div>
                </form>
            </div>
        </SiteLayout>
    );
};

export default TenantDetails;
